"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRead = void 0;
const react_1 = require("react");
const notification_context_1 = require("../../../modules/notification/notification-context");
const abortable_fetch_1 = require("../../../utils/abortable-fetch");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
function callApi(url, id) {
    return (0, abortable_fetch_1.abortableFetch)(`${url}/received/${id}/read`, {
        method: 'PUT',
    });
}
function useRead({ refresh }) {
    const fetch = (0, react_1.useRef)(null);
    const { notificationUrl } = (0, react_1.useContext)(notification_context_1.NotificationContext);
    const handleRead = (0, event_callback_hook_1.useEventCallback)(async (id) => {
        try {
            if (fetch.current !== null) {
                fetch.current.abort();
            }
            fetch.current = callApi(notificationUrl, id);
            await fetch.current.raw();
            refresh();
        }
        catch (err) {
            if (err instanceof Error) {
                if (err.name !== 'AbortError') {
                    throw err;
                }
            }
            else {
                console.log('Unexpected error', err);
            }
        }
    });
    return { handleRead };
}
exports.useRead = useRead;
//# sourceMappingURL=read-hook.js.map